import {
    BaseLayer,
    BaseLayerFactory_27700,
    BaseLayerFactory_3857,
    BaseLayerType
} from "esdm-map";

import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from "ol/layer/Tile";
import TileGrid from "ol/tilegrid/TileGrid";
import TileWMS from 'ol/source/TileWMS';

import * as olProj from 'ol/proj';
import proj4 from "proj4";
import { register } from 'ol/proj/proj4';
import Projection from "ol/proj/Projection";
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM';

export const WesternIslesBaseLayerTypes = {
    ...BaseLayerType,
    WesternIslesOS: 999,
    WesternIslesAerial: 1000,
};

export class WesternIslesBaseMapping_27700 extends BaseLayerFactory_27700 {

    private _baseLayerFactory_3857: BaseLayerFactory_3857;

    public constructor() {
        super();

        this._baseLayerFactory_3857 = new BaseLayerFactory_3857();
     
        proj4.defs('EPSG:27700', '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 ' +
            '+x_0=400000 +y_0=-100000 +ellps=airy ' +
            '+towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 ' +
            '+units=m +no_defs');
        register(proj4);
        var proj27700 = olProj.get('EPSG:27700');
        proj27700.setExtent([0, 0, 700000, 1300000]);
    }
    

    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string, esdmOsmApiKey:string): IBaseLayer {
        if (baseLayerType === WesternIslesBaseLayerTypes.WesternIslesOS) {
            return this.GetWesternIslesOS();
        }       

        if (baseLayerType === WesternIslesBaseLayerTypes.OSM_ESDM_contours) {
            return this.GetOSM_ESDM_contours27700(esdmOsmApiKey, "OSM_ESDM_contours", "OpenStreetMap");
        }   

        if (baseLayerType === WesternIslesBaseLayerTypes.WesternIslesAerial) {
            return this.GetWesternIslesAerial();
        }   

        //if (baseLayerType === WesternIslesBaseLayerTypes.OSM_ESDM_contours) {
        //    return this.GetOSM_ESDM_contours3857(esdmOsmApiKey, "OSM_ESDM_contours", "OpenStreetMap");
        //}   

        //if (baseLayerType == HighlandBaseLayerTypes.BingAerial || baseLayerType === HighlandBaseLayerTypes.OSM_ESDM_contours) {
        //if (baseLayerType == WesternIslesBaseLayerTypes.BingAerial) {
        //    return this._baseLayerFactory_3857.GetBaseLayerByType(baseLayerType, bingApiKey, esdmOsmApiKey);
        //}              

        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmOsmApiKey);
    }

    
    //Currently reprojecting to 3857 as disc is full so tiles for 27700 are not getting cached for the higher numbered zoom level
    //to switch when the new map tile server is up & running
    //private GetOSM_ESDM_contours3857(esdmApiKey: string, ref: string, displayName: string): IBaseLayer {
    //    let lyr = new TileLayer({
    //        source: new OSM({
    //            url: `//{a-f}.osm.esdm.co.uk/900913/c/{z}/{x}/{y}.png?APIKEY=${esdmApiKey}`,
    //            //url: `//osm-proxy.esdm.co.uk/900913/c/{z}/{x}/{y}.png?APIKEY=${esdmApiKey}`,
    //            maxZoom: 18
    //        })
    //    });

    //    return new BaseLayer(ref, displayName, lyr);
    //}

    private GetOSM_ESDM_contours27700(esdmApiKey: string, ref: string, displayName: string): IBaseLayer {
        let lyr = new TileLayer({
            source: new XYZ({
                projection: new Projection({
                    code: 'EPSG:27700',
                    extent: [-350000, -100000, 1050000, 1300000]
                }),
                maxZoom:14,
                url: `//{a-f}.osm.esdm.co.uk/27700/c/{z}/{x}/{y}.png?APIKEY=${esdmApiKey}`,
            })
        });
        lyr.setVisible(false);

        return new BaseLayer(ref, displayName, lyr);
    }

    private GetWesternIslesOS(): IBaseLayer {
        let lyr = new TileLayer({
            visible: false,
            source: new TileWMS({
                urls: ["/api/OgcService/WesternIsles-OS"],
                params: {
                    LAYERS: 'viaEuropa_m0105',
                    //TILED: 'true',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:27700'
                },
                projection: "EPSG:27700",  
                crossOrigin: "Anonymous",
                attributions: [`© Crown copyright and database rights ${new Date().getFullYear()} OS AC0000811967.`,
                    'Use of this data is subject to <a href="/terms-and-conditions#os">terms and conditions</a>.']
            })
        });
        lyr.setVisible(false);

        return new BaseLayer("WesternIslesOS", "Ordnance Survey", lyr);
    }
    
    private GetWesternIslesAerial(): IBaseLayer {
        let lyr = new TileLayer({
            visible: true,
            source: new TileWMS({
                url: "/api/OgcService/WesternIsles-Aerial",
                params: {
                    LAYERS: 'APGB_Latest_UK_125mm',
                    TILED: 'true',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:27700'
                },
                projection: "EPSG:27700",
                crossOrigin: "Anonymous",
                attributions: ['© Bluesky International Limited and Getmapping Limited 1999 - 2023',
                    '© Bluesky International Limited 2024 and onwards.',
                    'Use of this data is subject to <a href="/terms-and-conditions#apgb">terms and conditions</a>'],

            })
        })

        return new BaseLayer("WesternIslesAerial", "Aerial", lyr);
    }

}